export default "__VITE_PUBLIC_ASSET__0491455d__"